/* Art Bros – Bilderwand-Planer (v3: freie Größen, frei verschieben, eigenes Bild, Raumfotos) */
(function () {
  const root = document.querySelector('[data-ab-planner]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const CFG = JSON.parse($('[data-ab-planner-config]').textContent);
  let ROOMS = [];
  try { ROOMS = JSON.parse($('[data-ab-rooms]').textContent); } catch (_) {}
  if (!ROOMS.length) ROOMS = [{ id: 'sofa', name: 'Wohnzimmer', furn: 'sofa', img: '' }];

  const GAP = 5; // cm zwischen den Bildern – passend zur Hängeschablone
  const SIZES = { S: [30, 42], M: [40, 60], L: [50, 70], XL: [60, 80] };
  const LABEL = (k) => SIZES[k][0] + ' × ' + SIZES[k][1] + ' cm';
  const FRAME_COL = { 'Schwarzer Rahmen': '#1d1d1d', 'Weißer Rahmen': '#f6f4f0', 'Holzoptik-Rahmen': '#b98a5a', 'Ohne Rahmen': null };
  const FURN = { sofa: { w: 210, h: 85 }, sideboard: { w: 180, h: 75 }, bett: { w: 180, h: 100 } };
  const ICON = (rects) => '<svg viewBox="0 0 38 24" aria-hidden="true">' + rects.map((r) => '<rect x="' + r[0] + '" y="' + r[1] + '" width="' + r[2] + '" height="' + r[3] + '"/>').join('') + '</svg>';
  const PRESETS = {
    solo: { name: 'Einzelbild', n: 1, type: 'row', icon: ICON([[14, 2, 10, 20]]) },
    duo: { name: 'Duo', n: 2, type: 'row', icon: ICON([[8, 3, 10, 18], [20, 3, 10, 18]]) },
    reihe: { name: '3er-Reihe', n: 3, type: 'row', icon: ICON([[3, 4, 9, 16], [14.5, 4, 9, 16], [26, 4, 9, 16]]) },
    raster: { name: 'Raster 2×2', n: 4, type: 'grid', icon: ICON([[11, 1, 7, 10.5], [20, 1, 7, 10.5], [11, 12.5, 7, 10.5], [20, 12.5, 7, 10.5]]) },
    salon: { name: 'Salon', n: 5, type: 'salon', icon: ICON([[4, 2, 7, 9.5], [4, 12.5, 7, 9.5], [13, 2, 12, 20], [27, 2, 7, 9.5], [27, 12.5, 7, 9.5]]) },
    frei: { name: 'Frei', n: 0, type: 'free', icon: ICON([[3, 6, 8, 12], [13, 2, 11, 15], [26, 9, 9, 12]]) },
  };
  const ROW_NAME = { 1: 'solo', 2: 'duo', 3: 'reihe' };
  const fmt = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const imgUrl = (src, w) => src + (src.includes('?') ? '&' : '?') + 'width=' + w;
  const shortTitle = (t) => t.replace(/\s+(Wandbild|Kunstdruck|Poster)$/i, '');
  const dims = (it) => SIZES[it.k];

  // items: { k, cx, cy, pick } – cx/cy = Bildmitte in cm relativ zur Möbelmitte bzw. zur Hängelinie (Unterkante)
  // pick: null | { t: 'p', id } | { t: 'u', name, url, w, h, file }
  const state = { room: ROOMS[0].id, layout: 'reihe', size: 'M', frame: 'Schwarzer Rahmen', items: [], memo: [], mount: '', active: -1 };

  // ---------- Anordnen ----------
  function arrange(type, items) {
    const n = items.length, fw = FRAME_COL[state.frame] ? 2.2 : 0;
    const w = (i) => dims(items[i])[0] + 2 * fw, h = (i) => dims(items[i])[1] + 2 * fw;
    if (type === 'row') {
      const total = items.reduce((s, _, i) => s + w(i), 0) + GAP * (n - 1);
      const H = Math.max(...items.map((_, i) => h(i)));
      let x = -total / 2;
      items.forEach((it, i) => { it.cx = x + w(i) / 2; it.cy = -H / 2; x += w(i) + GAP; });
    } else if (type === 'grid') {
      const cw = [Math.max(w(0), w(2) || 0), Math.max(w(1), w(3) || 0)], rh = [Math.max(h(0), h(1)), Math.max(h(2) || 0, h(3) || 0)];
      const W = cw[0] + GAP + cw[1], H = rh[0] + GAP + rh[1];
      items.forEach((it, i) => { const c = i % 2, r = Math.floor(i / 2); it.cx = -W / 2 + (c ? cw[0] + GAP + cw[1] / 2 : cw[0] / 2); it.cy = -H + (r ? rh[0] + GAP + rh[1] / 2 : rh[0] / 2); });
    } else if (type === 'salon') {
      const wl = Math.max(w(0), w(1)), hl = h(0) + GAP + h(1), wc = w(2), hc = h(2), wr = Math.max(w(3), w(4)), hr = h(3) + GAP + h(4);
      const W = wl + GAP + wc + GAP + wr, H = Math.max(hl, hc, hr);
      const xl = -W / 2 + wl / 2, xc = -W / 2 + wl + GAP + wc / 2, xr = W / 2 - wr / 2;
      items[0].cx = xl; items[0].cy = -H / 2 - hl / 2 + h(0) / 2;
      items[1].cx = xl; items[1].cy = -H / 2 + hl / 2 - h(1) / 2;
      items[2].cx = xc; items[2].cy = -H / 2;
      items[3].cx = xr; items[3].cy = -H / 2 - hr / 2 + h(3) / 2;
      items[4].cx = xr; items[4].cy = -H / 2 + hr / 2 - h(4) / 2;
    }
  }
  function reflow() { const P = PRESETS[state.layout]; if (P && P.type !== 'free') arrange(P.type, state.items); }
  function remember() { state.items.forEach((it, i) => { if (it.pick) state.memo[i] = it.pick; }); }
  function applyPreset(name) {
    const P = PRESETS[name]; if (!P) return;
    state.layout = name;
    if (P.type === 'free') return;
    remember();
    const old = state.items;
    state.items = Array.from({ length: P.n }, (_, i) => ({
      k: P.type === 'salon' ? (i === 2 ? state.size : (state.size === 'S' ? 'S' : 'S')) : state.size,
      pick: old[i] ? old[i].pick : state.memo[i] || null,
    }));
    if (P.type === 'salon' && state.size === 'S') state.items[2].k = 'M';
    reflow();
  }
  function setAllSizes(k) {
    state.size = k;
    if (state.layout === 'salon') { state.items[2].k = k; }
    else state.items.forEach((it) => { it.k = k; });
    reflow();
  }
  function bbox() {
    const fw = FRAME_COL[state.frame] ? 2.2 : 0;
    let l = Infinity, r = -Infinity, t = Infinity, b = -Infinity;
    state.items.forEach((it) => { const [w, h] = dims(it); l = Math.min(l, it.cx - w / 2 - fw); r = Math.max(r, it.cx + w / 2 + fw); t = Math.min(t, it.cy - h / 2 - fw); b = Math.max(b, it.cy + h / 2 + fw); });
    return { l, r, t, b, w: r - l, h: b - t };
  }

  // ---------- Katalog ----------
  let catalog = []; const byId = new Map(); const collIds = {};
  async function loadCatalog() {
    for (let page = 1; page < 6; page++) {
      const r = await fetch('/collections/all/products.json?limit=250&page=' + page).then((x) => x.json());
      r.products.forEach((p) => {
        if (!/Wandbild/i.test(p.product_type) || /Set|Bundle|Personalisiert|Zubehör/i.test(p.product_type) || !p.images.length) return;
        if (!p.variants.some((v) => v.available)) return;
        const o = { id: p.id, title: shortTitle(p.title), img: p.images[0].src, hay: (p.title + ' ' + p.tags.join(' ') + ' ' + p.product_type).toLowerCase(), variants: p.variants.map((v) => ({ id: v.id, option1: v.option1, option2: v.option2, price: Math.round(parseFloat(v.price) * 100), available: v.available })) };
        catalog.push(o); byId.set(o.id, o);
      });
      if (r.products.length < 250) break;
    }
  }
  async function loadCollIds(h) {
    if (collIds[h]) return collIds[h];
    const ids = new Set();
    for (let page = 1; page < 4; page++) {
      const r = await fetch('/collections/' + h + '/products.json?limit=250&page=' + page).then((x) => x.json());
      r.products.forEach((p) => ids.add(p.id)); if (r.products.length < 250) break;
    }
    return (collIds[h] = ids);
  }

  // ---------- Hash (Plan teilen) ----------
  function readHash() {
    const p = new URLSearchParams(location.hash.slice(1));
    if (ROOMS.some((r) => r.id === p.get('room'))) state.room = p.get('room');
    if (p.get('r') in FRAME_COL) state.frame = p.get('r');
    if (SIZES[p.get('k')]) state.size = p.get('k');
    const L = PRESETS[p.get('l')] ? p.get('l') : 'reihe';
    const its = (p.get('i') || '').split('.').filter(Boolean).map((s) => { const [id, k, cx, cy] = s.split('_'); return SIZES[k] ? { k, cx: +cx || 0, cy: +cy || 0, pick: +id ? { t: 'p', id: +id } : null } : null; }).filter(Boolean);
    if (its.length) { state.items = its; state.layout = L; if (L !== 'frei' && PRESETS[L].n === its.length) reflow(); }
    else if (p.get('p')) { // ältere Links (v2)
      applyPreset(L);
      p.get('p').split('.').forEach((x, i) => { if (state.items[i] && +x) state.items[i].pick = { t: 'p', id: +x }; });
    } else applyPreset(L);
    state.openUp = !!p.get('up');
  }
  function writeHash() {
    const i = state.items.map((it) => (it.pick && it.pick.t === 'p' ? it.pick.id : 0) + '_' + it.k + '_' + Math.round(it.cx) + '_' + Math.round(it.cy)).join('.');
    const p = new URLSearchParams({ room: state.room, l: state.layout, k: state.size, r: state.frame, i });
    history.replaceState(null, '', '#' + p.toString());
  }

  const room = () => ROOMS.find((r) => r.id === state.room) || ROOMS[0];
  function variantFor(pick, k) {
    if (!pick) return null;
    const size = LABEL(k);
    const list = pick.t === 'u' ? CFG.own || [] : (byId.get(pick.id) || {}).variants || [];
    return list.find((v) => v.option1 === size && v.option2 === state.frame && v.available) || null;
  }
  function pickInfo(pick) {
    if (!pick) return null;
    if (pick.t === 'u') return { title: 'Dein Bild', img: pick.url, sub: pick.name };
    const p = byId.get(pick.id); return p ? { title: p.title, img: imgUrl(p.img, 500) } : null;
  }
  function dpiInfo(pick, k) {
    if (!pick || pick.t !== 'u') return null;
    const [w, h] = SIZES[k]; const dpi = Math.min(pick.w / (w / 2.54), pick.h / (h / 2.54));
    return { dpi: Math.round(dpi), ok: dpi >= 100 };
  }

  // ---------- Bühne ----------
  let geo = null; // aktuelle Geometrie der Bühne (für Drag)
  function stageGeometry() {
    const R = room();
    if (R.img && R.cmW) { const W = R.cmW, H = R.cmW * R.h / R.w; return { R, W, H, ax: W * R.cx, ay: H * R.top - (R.gap || 25), furnTop: H * R.top }; }
    const f = FURN[R.furn] || FURN.sofa, W = 320, H = 213, floor = H - 14;
    return { R, W, H, ax: W / 2, ay: floor - f.h - 25, furnTop: floor - f.h, f, floor };
  }
  function renderStage() {
    const G = geo = stageGeometry(), R = G.R, bb = bbox();
    const col = FRAME_COL[state.frame], fw = col ? 2.2 : 0;
    let svg = '', y0 = 0;
    if (R.img && R.cmW) {
      svg += '<image href="' + esc(R.img) + '" x="0" y="0" width="' + G.W + '" height="' + G.H + '" preserveAspectRatio="none"/>';
      const need = G.ay + bb.t - 22;
      if (need < 0 && R.wall) {
        y0 = need;
        const stops = R.wall.map((c, i) => '<stop offset="' + (i / (R.wall.length - 1)) + '" stop-color="' + c + '"/>').join('');
        svg += '<defs><linearGradient id="abplw" x1="0" x2="1" y1="0" y2="0">' + stops + '</linearGradient>' +
          '<linearGradient id="abplf" gradientUnits="userSpaceOnUse" x1="0" x2="0" y1="0" y2="10"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#000"/></linearGradient>' +
          '<mask id="abplm" maskUnits="userSpaceOnUse" x="0" y="' + y0 + '" width="' + G.W + '" height="' + (10 - y0) + '"><rect x="0" y="' + y0 + '" width="' + G.W + '" height="' + (-y0) + '" fill="#fff"/><rect x="0" y="0" width="' + G.W + '" height="10" fill="url(#abplf)"/></mask>' +
          '<filter id="abpln"><feTurbulence type="fractalNoise" baseFrequency="1.4" numOctaves="2" seed="3"/><feColorMatrix values="0 0 0 0 0.45  0 0 0 0 0.42  0 0 0 0 0.38  0 0 0 0.10 0"/><feComposite in2="SourceGraphic" operator="in"/></filter></defs>' +
          '<g mask="url(#abplm)"><rect x="0" y="' + y0 + '" width="' + G.W + '" height="' + (10 - y0) + '" fill="url(#abplw)"/><rect x="0" y="' + y0 + '" width="' + G.W + '" height="' + (10 - y0) + '" fill="#fff" filter="url(#abpln)"/></g>';
      }
    } else {
      const f = G.f, fx = G.W / 2 - f.w / 2, fy = G.floor - f.h;
      svg += '<rect width="' + G.W + '" height="' + G.H + '" fill="#efeae2"/><rect y="' + G.floor + '" width="' + G.W + '" height="14" fill="#d9cdb9"/>';
      svg += '<rect x="' + fx + '" y="' + fy + '" width="' + f.w + '" height="' + f.h + '" rx="5" fill="#c9c0b1"/>';
      y0 = Math.min(0, G.ay + bb.t - 22);
      if (y0 < 0) svg = '<rect x="0" y="' + y0 + '" width="' + G.W + '" height="' + (-y0 + 1) + '" fill="#efeae2"/>' + svg;
    }
    svg = '<svg viewBox="0 ' + y0 + ' ' + G.W + ' ' + (G.H - y0) + '" role="img" aria-label="Vorschau deiner Bilderwand"><defs><filter id="abplsh" x="-20%" y="-20%" width="140%" height="150%"><feDropShadow dx="0.4" dy="1.4" stdDeviation="1.1" flood-color="#000" flood-opacity=".28"/></filter></defs>' + svg;
    state.items.forEach((it, i) => {
      const [w, h] = dims(it); const x = G.ax + it.cx - w / 2, y = G.ay + it.cy - h / 2; const info = pickInfo(it.pick);
      const cls = 'ab-pl__slot' + (info ? '' : ' ab-pl__slot--empty') + (state.active === i ? ' is-active' : '');
      svg += '<g class="' + cls + '" data-slot="' + i + '" tabindex="0" role="button" aria-label="Bild ' + (i + 1) + (info ? ': ' + esc(info.title) + ' – ändern oder verschieben' : ' – Motiv wählen') + '">';
      if (info) {
        svg += '<rect x="' + (x - fw) + '" y="' + (y - fw) + '" width="' + (w + 2 * fw) + '" height="' + (h + 2 * fw) + '" fill="' + (col || '#fff') + '" filter="url(#abplsh)"/>';
        svg += '<image href="' + esc(info.img) + '" x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid slice"/>';
        if (col) svg += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="none" stroke="rgba(0,0,0,.18)" stroke-width=".25"/>';
      } else {
        svg += '<rect class="ab-pl__ph" x="' + (x - fw) + '" y="' + (y - fw) + '" width="' + (w + 2 * fw) + '" height="' + (h + 2 * fw) + '"/>';
        const fs = Math.max(5, Math.min(w, h) * 0.2);
        svg += '<text x="' + (x + w / 2) + '" y="' + (y + h / 2 + fs * 0.1) + '" text-anchor="middle" font-family="sans-serif" font-size="' + fs + '" fill="#6b665f">+</text>';
        svg += '<text x="' + (x + w / 2) + '" y="' + (y + h / 2 + fs * 0.85) + '" text-anchor="middle" font-family="sans-serif" font-size="' + Math.max(3, fs * 0.32) + '" fill="#6b665f">Motiv wählen</text>';
      }
      svg += '<rect class="ab-pl__hl" x="' + (x - fw - 0.6) + '" y="' + (y - fw - 0.6) + '" width="' + (w + 2 * fw + 1.2) + '" height="' + (h + 2 * fw + 1.2) + '" fill="none"/></g>';
    });
    const ox = G.ax + bb.l, my = G.ay + bb.t - 9, cx = G.ax + (bb.l + bb.r) / 2;
    svg += '<g class="ab-pl__dim" opacity=".75" pointer-events="none"><line x1="' + ox + '" y1="' + my + '" x2="' + (ox + bb.w) + '" y2="' + my + '" stroke="#4a4744" stroke-width=".35"/><line x1="' + ox + '" y1="' + (my - 2) + '" x2="' + ox + '" y2="' + (my + 2) + '" stroke="#4a4744" stroke-width=".35"/><line x1="' + (ox + bb.w) + '" y1="' + (my - 2) + '" x2="' + (ox + bb.w) + '" y2="' + (my + 2) + '" stroke="#4a4744" stroke-width=".35"/>';
    svg += '<text x="' + cx + '" y="' + (my - 2.5) + '" text-anchor="middle" font-size="' + Math.max(4, G.W / 70) + '" fill="#2f2d2a" font-family="sans-serif">' + Math.round(bb.w) + ' × ' + Math.round(bb.h) + ' cm</text></g>';
    svg += '<g class="ab-pl__guides" pointer-events="none"></g></svg>';
    $('[data-ab-pl-stage]').innerHTML = svg;
  }

  // ---------- Liste + Summe ----------
  function renderSide() {
    const its = state.items;
    const filled = its.filter((it) => it.pick).length;
    $('[data-ab-pl-progress]').textContent = filled + ' von ' + its.length + ' gewählt';
    $('[data-ab-pl-slots]').innerHTML = its.map((it, i) => {
      const info = pickInfo(it.pick), d = dpiInfo(it.pick, it.k), v = variantFor(it.pick, it.k);
      const sel = '<select data-size="' + i + '" aria-label="Größe von Bild ' + (i + 1) + '">' + Object.keys(SIZES).map((k) => '<option value="' + k + '"' + (k === it.k ? ' selected' : '') + '>' + LABEL(k) + '</option>').join('') + '</select>';
      return '<li class="' + (state.active === i ? 'is-active' : '') + '"><span class="ab-pl__num">' + (i + 1) + '</span>' +
        (info ? '<img class="ab-pl__thumb" src="' + esc(info.img) + '" alt="">' : '<button type="button" class="ab-pl__thumb ab-pl__thumb--empty" data-pick="' + i + '" aria-label="Motiv für Bild ' + (i + 1) + ' wählen">+</button>') +
        '<span class="ab-pl__meta"><b>' + (info ? esc(info.title) : 'Noch leer') + '</b><span class="ab-pl__line">' + sel + (v ? '<span class="ab-pl__pr">' + fmt(v.price) + '</span>' : '') + '</span>' +
        (d ? '<span class="' + (d.ok ? 'ab-pl__ok' : 'ab-pl__warn') + '">' + (d.ok ? 'Auflösung gut (' + d.dpi + ' dpi)' : 'Auflösung zu gering (' + d.dpi + ' dpi) – kleiner wählen oder größeres Bild') + '</span>' : '') +
        (it.pick && !v ? '<span class="ab-pl__warn">In dieser Ausführung nicht verfügbar</span>' : '') + '</span>' +
        '<span class="ab-pl__acts"><button type="button" class="' + (info ? '' : 'ab-pl__pick') + '" data-pick="' + i + '">' + (info ? 'Ändern' : 'Wählen') + '</button>' + (its.length > 1 ? '<button type="button" class="ab-pl__rm" data-rm="' + i + '" aria-label="Bild ' + (i + 1) + ' entfernen" title="Bild entfernen">✕</button>' : '') + '</span></li>';
    }).join('');

    let sum = 0, ok = filled === its.length && its.length > 0;
    const rows = its.map((it) => {
      if (!it.pick) return '';
      const v = variantFor(it.pick, it.k); if (!v) { ok = false; return ''; }
      const d = dpiInfo(it.pick, it.k); if (d && d.dpi < 60) ok = false;
      sum += v.price; return '<li><span>' + esc(pickInfo(it.pick).title) + '</span><span>' + LABEL(it.k) + '</span><span>' + fmt(v.price) + '</span></li>';
    }).join('');
    let mountSum = 0;
    if (state.mount) { const mv = CFG.mount.find((m) => String(m.id) === state.mount); if (mv) mountSum = mv.price * filled; }
    const D = CFG.discount || {}, gross = sum + mountSum;
    const disc = D.percent && filled >= (D.min || 2) ? Math.round(gross * D.percent / 100) : 0;
    $('[data-ab-pl-list]').innerHTML = rows + (mountSum ? '<li><span>Montageset</span><span>' + filled + ' ×</span><span>' + fmt(mountSum) + '</span></li>' : '') + (disc ? '<li class="ab-pl__disc"><span>' + esc(D.title) + '</span><span></span><span>−' + fmt(disc) + '</span></li>' : '');
    $('[data-ab-pl-total]').textContent = fmt(gross - disc);
    $('[data-ab-pl-count]').textContent = filled + (filled === 1 ? ' Bild' : ' Bilder') + ' · ' + state.frame;
    const hint = $('[data-ab-pl-dischint]');
    if (hint) hint.hidden = !(D.percent && filled < (D.min || 2));
    const hasUp = its.some((it) => it.pick && it.pick.t === 'u');
    $('[data-ab-pl-rights]').hidden = !hasUp;
    const rightsOk = !hasUp || $('[data-ab-pl-rights-cb]').checked;
    const add = $('[data-ab-pl-add]');
    add.disabled = !ok || !rightsOk;
    add.textContent = filled < its.length ? 'Noch ' + (its.length - filled) + (its.length - filled === 1 ? ' Motiv' : ' Motive') + ' wählen' : !rightsOk ? 'Bitte Bildrechte bestätigen' : 'Ganze Wand in den Warenkorb';
  }

  function render() { renderStage(); renderSide(); writeHash(); }

  // ---------- Bedienelemente ----------
  function renderControls() {
    $('[data-ab-pl-rooms]').innerHTML = ROOMS.map((r) => '<button type="button" value="' + r.id + '" aria-pressed="' + (r.id === state.room) + '">' + (r.img ? '<img src="' + esc(imgUrl(r.img, 120)) + '" alt="">' : '') + esc(r.name) + '</button>').join('');
    $('[data-ab-pl-layouts]').innerHTML = Object.entries(PRESETS).map(([k, L]) => '<button type="button" value="' + k + '" aria-pressed="' + (k === state.layout) + '">' + L.icon + '<span>' + L.name + '</span></button>').join('');
    const same = state.items.length && state.items.every((it) => it.k === state.items[0].k) ? state.items[0].k : (state.layout === 'salon' ? state.items[2].k : null);
    $('[data-ab-pl-sizes]').innerHTML = Object.keys(SIZES).map((k) => '<button type="button" value="' + k + '" aria-pressed="' + (k === same) + '">' + LABEL(k) + '</button>').join('');
    $('[data-ab-pl-sizelabel]').textContent = state.layout === 'salon' ? '2. Größe des Mittelbilds' : '2. Bildgröße für alle';
    root.querySelectorAll('[data-ab-pl-frames] button').forEach((b) => b.setAttribute('aria-pressed', String(b.value === state.frame)));
  }
  function update() { renderControls(); render(); }
  root.addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    const grp = b.parentElement;
    if (grp.matches('[data-ab-pl-rooms]')) state.room = b.value;
    else if (grp.matches('[data-ab-pl-layouts]')) applyPreset(b.value);
    else if (grp.matches('[data-ab-pl-sizes]')) setAllSizes(b.value);
    else if (grp.matches('[data-ab-pl-frames]')) { state.frame = b.value; reflow(); }
    else if (b.matches('[data-ab-pl-addslot]')) { addSlot(); return; }
    else if (b.matches('[data-pick]')) { openPicker(+b.dataset.pick); return; }
    else if (b.matches('[data-rm]')) { removeSlot(+b.dataset.rm); return; }
    else return;
    update();
  });
  root.addEventListener('change', (e) => {
    const s = e.target.closest('[data-size]'); if (!s) return;
    const it = state.items[+s.dataset.size]; it.k = s.value; reflow(); update();
  });
  function addSlot() {
    remember();
    const bb = state.items.length ? bbox() : { r: -GAP, t: -60, b: 0 };
    const k = state.size, [w, h] = SIZES[k], fw = FRAME_COL[state.frame] ? 2.2 : 0;
    const n = state.items.length + 1;
    const it = { k, pick: state.memo[n - 1] || null, cx: bb.r + GAP + w / 2 + fw, cy: (bb.t + bb.b) / 2 };
    state.items.push(it);
    const P = PRESETS[state.layout];
    if (P.type === 'row' && ROW_NAME[n]) { state.layout = ROW_NAME[n]; reflow(); }
    else if (P.type === 'row' && n <= 6) { arrange('row', state.items); state.layout = 'frei'; }
    else state.layout = 'frei';
    recenter(); update();
    if (!it.pick) openPicker(n - 1);
  }
  function removeSlot(i) {
    if (state.items.length < 2) return;
    const it = state.items[i]; if (it.pick && it.pick.t === 'u') URL.revokeObjectURL(it.pick.url);
    state.items.splice(i, 1); state.memo.splice(i, 1);
    const P = PRESETS[state.layout], n = state.items.length;
    if (P.type === 'row' && ROW_NAME[n]) { state.layout = ROW_NAME[n]; reflow(); }
    else if (P.type === 'row') arrange('row', state.items);
    else if (P.type !== 'free') state.layout = 'frei';
    update();
  }
  function recenter() { // freie Anordnung mittig über dem Möbel halten, wenn sie zu weit hinausragt
    const bb = bbox(), G = stageGeometry(), half = G.W / 2 - 6;
    if (bb.l + G.ax < 6 || bb.r + G.ax > G.W - 6) { const dx = -(bb.l + bb.r) / 2; state.items.forEach((it) => { it.cx += dx; }); }
    void half;
  }
  const mountSel = $('[data-ab-pl-mount]');
  if (mountSel) mountSel.addEventListener('change', () => { state.mount = mountSel.value; renderSide(); });
  $('[data-ab-pl-rights-cb]').addEventListener('change', renderSide);

  // ---------- Frei verschieben (Maus & Touch) ----------
  const stage = $('[data-ab-pl-stage]');
  let drag = null;
  const SNAP = 2.5;
  function snapPos(i, cx, cy) {
    const it = state.items[i], [w, h] = dims(it), fw = FRAME_COL[state.frame] ? 2.2 : 0, W = w / 2 + fw, H = h / 2 + fw;
    const gx = [], gy = [];
    let bx = null, by = null, dx = SNAP, dy = SNAP;
    const tryX = (v, line) => { const d = Math.abs(cx - v); if (d < dx) { dx = d; bx = v; gx.length = 0; gx.push(line); } };
    const tryY = (v, line) => { const d = Math.abs(cy - v); if (d < dy) { dy = d; by = v; gy.length = 0; gy.push(line); } };
    tryX(0, 0);
    state.items.forEach((o, j) => {
      if (j === i) return;
      const [ow, oh] = dims(o), OW = ow / 2 + fw, OH = oh / 2 + fw;
      tryX(o.cx, o.cx); tryX(o.cx - OW + W, o.cx - OW); tryX(o.cx + OW - W, o.cx + OW);
      tryX(o.cx + OW + GAP + W, null); tryX(o.cx - OW - GAP - W, null);
      tryY(o.cy, o.cy); tryY(o.cy - OH + H, o.cy - OH); tryY(o.cy + OH - H, o.cy + OH);
      tryY(o.cy + OH + GAP + H, null); tryY(o.cy - OH - GAP - H, null);
    });
    return { cx: bx !== null ? bx : Math.round(cx), cy: by !== null ? by : Math.round(cy), gx: bx !== null ? gx : [], gy: by !== null ? gy : [] };
  }
  function clampPos(i, p) {
    const G = geo || stageGeometry(), it = state.items[i], [w, h] = dims(it), fw = FRAME_COL[state.frame] ? 2.2 : 0;
    const minX = -G.ax + w / 2 + fw + 2, maxX = G.W - G.ax - w / 2 - fw - 2;
    const maxY = (G.furnTop - G.ay) - h / 2 - fw - 3; // nicht ins Möbel
    p.cx = Math.min(maxX, Math.max(minX, p.cx)); p.cy = Math.min(maxY, Math.max(-260, p.cy));
    return p;
  }
  stage.addEventListener('pointerdown', (e) => {
    const g = e.target.closest('.ab-pl__slot'); if (!g || e.button > 0) return;
    const svg = stage.querySelector('svg'); const vb = svg.viewBox.baseVal;
    const i = +g.dataset.slot;
    drag = { i, g, svg, sx: e.clientX, sy: e.clientY, ox: state.items[i].cx, oy: state.items[i].cy, scale: vb.width / svg.getBoundingClientRect().width, moved: false, id: e.pointerId };
    g.setPointerCapture(e.pointerId);
  });
  stage.addEventListener('pointermove', (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    const ddx = e.clientX - drag.sx, ddy = e.clientY - drag.sy;
    if (!drag.moved && Math.hypot(ddx, ddy) < 6) return;
    drag.moved = true; drag.g.classList.add('is-dragging');
    const p = clampPos(drag.i, snapPos(drag.i, drag.ox + ddx * drag.scale, drag.oy + ddy * drag.scale));
    drag.cx = p.cx; drag.cy = p.cy;
    drag.g.setAttribute('transform', 'translate(' + (p.cx - drag.ox) + ' ' + (p.cy - drag.oy) + ')');
    const G = geo, vb = drag.svg.viewBox.baseVal;
    drag.svg.querySelector('.ab-pl__guides').innerHTML =
      p.gx.filter((v) => v !== null).map((v) => '<line x1="' + (G.ax + v) + '" x2="' + (G.ax + v) + '" y1="' + vb.y + '" y2="' + (G.furnTop) + '" stroke="#7a2e2a" stroke-width=".3" stroke-dasharray="1.5 1"/>').join('') +
      p.gy.filter((v) => v !== null).map((v) => '<line y1="' + (G.ay + v) + '" y2="' + (G.ay + v) + '" x1="0" x2="' + G.W + '" stroke="#7a2e2a" stroke-width=".3" stroke-dasharray="1.5 1"/>').join('');
    e.preventDefault();
  });
  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    const d = drag; drag = null;
    if (!d.moved) { if (e && e.type === 'pointerup') openPicker(d.i); return; }
    state.items[d.i].cx = d.cx; state.items[d.i].cy = d.cy;
    state.layout = 'frei';
    update();
  }
  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);
  root.addEventListener('keydown', (e) => {
    const s = e.target.closest && e.target.closest('.ab-pl__slot'); if (!s) return;
    const i = +s.dataset.slot;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPicker(i); return; }
    const mv = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
    if (mv) { e.preventDefault(); const st = e.shiftKey ? 10 : 1; const p = clampPos(i, { cx: state.items[i].cx + mv[0] * st, cy: state.items[i].cy + mv[1] * st }); state.items[i].cx = p.cx; state.items[i].cy = p.cy; state.layout = 'frei'; update(); stage.querySelector('[data-slot="' + i + '"]')?.focus(); }
  });

  // ---------- Motivauswahl ----------
  const dlg = $('[data-ab-pl-dlg]'), cards = $('[data-ab-pl-cards]'), more = $('[data-ab-pl-more]'), q = $('[data-ab-pl-q]'), fileIn = $('[data-ab-pl-file]');
  let shown = 0, filtered = [], collFilter = '';
  const PAGE = 40;
  function openPicker(i) {
    state.active = i; renderStage(); renderSide();
    $('[data-ab-pl-dlg-title]').textContent = 'Motiv für Bild ' + (i + 1) + ' wählen · ' + LABEL(state.items[i].k);
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    applyFilter();
    if (matchMedia('(min-width: 700px)').matches) setTimeout(() => q.focus(), 50);
  }
  function closePicker() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', () => { state.active = -1; renderStage(); renderSide(); });
  dlg.addEventListener('click', (e) => { if (e.target === dlg) closePicker(); });
  $('[data-ab-pl-close]').addEventListener('click', closePicker);

  async function applyFilter() {
    const term = q.value.trim().toLowerCase();
    let ids = null;
    if (collFilter) { cards.innerHTML = '<p class="ab-pl__empty">Lädt …</p>'; ids = await loadCollIds(collFilter); }
    filtered = catalog.filter((p) => (!ids || ids.has(p.id)) && (!term || term.split(/\s+/).every((t) => p.hay.includes(t))));
    shown = 0; cards.innerHTML = ''; drawCards();
  }
  function drawCards() {
    const used = new Set(state.items.filter((it) => it.pick && it.pick.t === 'p').map((it) => it.pick.id));
    const k = (state.items[state.active] || {}).k || 'M';
    let html = '';
    if (shown === 0 && CFG.own) html += '<button type="button" class="ab-pl__card ab-pl__card--up" data-up><span class="ab-pl__up"><b>+</b><span>Eigenes Bild hochladen</span><small>JPG oder PNG, möglichst groß</small></span><span>Dein Foto als Wandbild</span></button>';
    if (!catalog.length) html += '<p class="ab-pl__empty">Motive werden geladen …</p>';
    else if (!filtered.length) html += '<p class="ab-pl__empty">Kein Motiv gefunden – probier einen anderen Begriff.</p>';
    filtered.slice(shown, shown + PAGE).forEach((p) => {
      const v = p.variants.find((x) => x.option1 === LABEL(k) && x.option2 === state.frame);
      html += '<button type="button" class="ab-pl__card' + (used.has(p.id) ? ' is-used' : '') + '" data-id="' + p.id + '"><img loading="lazy" src="' + esc(imgUrl(p.img, 360)) + '" alt=""><span>' + esc(p.title) + '</span>' + (v ? '<small>' + fmt(v.price) + (used.has(p.id) ? ' · schon an deiner Wand' : '') + '</small>' : '') + '</button>';
    });
    cards.insertAdjacentHTML('beforeend', html);
    shown += PAGE; more.hidden = shown >= filtered.length;
  }
  more.addEventListener('click', drawCards);
  let qt; q.addEventListener('input', () => { clearTimeout(qt); qt = setTimeout(applyFilter, 180); });
  $('[data-ab-pl-colls]').addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    e.stopPropagation();
    $('[data-ab-pl-colls]').querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    collFilter = b.value; applyFilter();
  });
  cards.addEventListener('click', (e) => {
    e.stopPropagation();
    if (e.target.closest('[data-up]')) { fileIn.value = ''; fileIn.click(); return; }
    const c = e.target.closest('[data-id]'); if (!c) return;
    choose({ t: 'p', id: +c.dataset.id });
  });
  function choose(pick) {
    const i = state.active; if (i < 0 || !state.items[i]) return;
    const old = state.items[i].pick; if (old && old.t === 'u' && old !== pick) URL.revokeObjectURL(old.url);
    state.items[i].pick = pick; state.memo[i] = pick;
    closePicker(); render();
  }
  fileIn.addEventListener('change', () => {
    const f = fileIn.files[0]; if (!f) return;
    if (!/image\/(jpeg|png)/.test(f.type)) { alert('Bitte ein JPG- oder PNG-Bild wählen.'); return; }
    if (f.size > 20 * 1024 * 1024) { alert('Das Bild ist größer als 20 MB. Bitte eine kleinere Datei wählen.'); return; }
    const url = URL.createObjectURL(f), im = new Image();
    im.onload = () => choose({ t: 'u', name: f.name, url, w: im.naturalWidth, h: im.naturalHeight, file: f });
    im.onerror = () => alert('Das Bild konnte nicht gelesen werden.');
    im.src = url;
  });

  // ---------- Warenkorb ----------
  async function addAll(btn) {
    const its = state.items;
    btn.disabled = true; const old = btn.textContent; btn.textContent = 'Wird hinzugefügt …';
    try {
      const json = [];
      for (let i = 0; i < its.length; i++) {
        const it = its[i], v = variantFor(it.pick, it.k);
        if (it.pick.t === 'u') {
          const fd = new FormData();
          fd.append('id', v.id); fd.append('quantity', 1);
          fd.append('properties[Dein Motiv]', it.pick.file, it.pick.file.name);
          fd.append('properties[Zuschnitt]', 'mittig auf ' + LABEL(it.k));
          fd.append('properties[_Galeriewand]', 'Planer, Bild ' + (i + 1));
          const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Upload fehlgeschlagen');
        } else json.push({ id: v.id, quantity: 1, properties: { '_Galeriewand': 'Planer, Bild ' + (i + 1) } });
      }
      if (state.mount) {
        const sizes = {}; its.forEach((it) => { const k = LABEL(it.k) + ' / ' + state.frame; sizes[k] = (sizes[k] || 0) + 1; });
        Object.entries(sizes).forEach(([s, n]) => json.push({ id: Number(state.mount), quantity: n, properties: { 'Für Bild': 'Galeriewand (Planer)', 'Schablone': s } }));
      }
      if (json.length) {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: json }) });
        if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Fehler');
      }
      const D = CFG.discount || {};
      location.href = D.code && its.length >= (D.min || 2) ? '/discount/' + encodeURIComponent(D.code) + '?redirect=%2Fcart' : '/cart';
    } catch (err) {
      btn.textContent = 'Fehler: ' + err.message; btn.disabled = false; setTimeout(() => { btn.textContent = old; }, 4000);
    }
  }
  $('[data-ab-pl-add]').addEventListener('click', (e) => addAll(e.currentTarget));
  $('[data-ab-pl-share]').addEventListener('click', async (e) => {
    const b = e.currentTarget;
    try { await navigator.clipboard.writeText(location.href); b.textContent = 'Link kopiert ✓'; } catch (_) { prompt('Link zu deinem Plan:', location.href); }
    setTimeout(() => (b.textContent = 'Plan als Link teilen'), 2500);
  });

  // ---------- Start ----------
  readHash(); renderControls(); render();
  if (state.openUp && CFG.own) openPicker(0);
  loadCatalog().then(() => {
    state.items.forEach((it) => { if (it.pick && it.pick.t === 'p' && !byId.has(it.pick.id)) it.pick = null; });
    render(); if (dlg.open) applyFilter();
  });
})();
